import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";
import AdminConfigsElementCard from "./AdminConfigsElementCard.js";
import CreateServiceElementCard from "./CreateServiceElementCard.js";

const config = require("../../../constants/constants.js")

const CreateEventtypePageComponent = ({
  createEventtypeApiRequest,
  uploadEventtypeImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
  reduxDispatch,
  newEventtype,
  deleteEventtype,
  saveAttributeToCatDoc
}) => {
  const [validated, setValidated] = useState(false);
  const [attributesTable, setAttributesTable] = useState([]);
  const [attributesFromDb, setAttributesFromDb] = useState([]);
  const [isCreating, setIsCreating] = useState("");
  const [createEventtypeResponseState, setCreateEventtypeResponseState] = useState({
    message: "",
    error: "",
  });

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [position, setPosition] = useState("");
  const [note, setNote] = useState("");
  const [color, setColor] = useState("");
  const [image, setImage] = useState("");
  const [images, setImages] = useState([]);

  const [displayPaperImages, setDisplayPaperImages] = useState("");
  const [idStoreImages, setIdStoreImages] = useState("");
  
  const navigate = useNavigate();

  const [eventtype, setEventtype] = useState({});

  const [page, setPage] = useState({});
  const [imageRemoved, setImageRemoved] = useState(false)
  const [isUploading, setIsUploading] = useState("");
  const [imageUploaded, setImageUploaded] = useState(false);
  const [id, setId] = useState("");
  const [pageImageItems, setPageImageItems] = useState([]);

  const url_image_elenco = config.URL_IMAGES_CUSTOMER1;

  function handleSalva(event) {

    event.preventDefault();
    event.stopPropagation();

    const formInputs = {
      name: name,
      description: description,
      position: position,
      note: note,
      color: color,
      images: images,
      image: "",
    };

    console.log('[handleSalva] formInputs=', formInputs)

    /*
    if (images.length > 10) {
      setIsCreating("to many files [max 10]");
      return;
    }
    */
    createEventtypeApiRequest(formInputs)
      .then((data) => {
        if (images) {
          console.log('[handleSalva] data=', data)
          console.log('[handleSalva] id =', data?.eventtypeId)
          setId(data?.eventtypeId);
          setIdStoreImages(data?.eventtypeId);
          console.log('[handleSalva] idStoreImages =', idStoreImages)
          window.location.assign(`/admin/edit-eventtype/${data?.eventtypeId}`)
        }
      })
      .catch((er) => {
        setCreateEventtypeResponseState({
          error: er.response.data.message
            ? er.response.data.message
            : er.response.data,
        });
      });
    //setDisplayPaperImages("block");
    //window.location.assign('/admin/products')
  };

const handleLoadImage = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;

    console.log("[handleLoadImage] event.target.files=" + event.target.files)
    console.log("[handleLoadImage] files.length=" + files.length)

    for (let i = 0; i < files.length; i++) {
      // ## controllo dimensione totale
      //
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }

    setIsUploading("upload files in corso ...");
    uploadImageEventtypeImagesApiRequest(event.target.files, id)
      .then(data => {
        //if (data.message === "eventtype updated") navigate("/admin/eventtypes");
        setIsUploading("upload files completato");
        setImageUploaded(!imageUploaded);
      })
      .catch((er) => setIsUploading(er.response.data.message ? er.response.data.message : er.response.data));
    window.location.assign(`/admin/edit-eventtype/${id}`)
  };

  const uploadImageEventtypeImagesApiRequest = async (images, eventtypeId) => {

    console.log("[uploadImageEventtypeImagesApiRequest]")
    console.log("[uploadImageEventtypeImagesApiRequest] images=", images)
    console.log("[uploadImageEventtypeImagesApiRequest] id=", eventtypeId)

    const formData = new FormData();
    Array.from(images).forEach((image) => {
      formData.append("images", image);
    });

    console.log("[uploadImageEventtypeImagesApiRequest] formData=", formData)
    console.log("[uploadImageEventtypeImagesApiRequest] POST /api/eventtypes/admin/upload?eventtypeId")

    const { data } = await axios.post("/api/eventtypes/admin/upload?eventtypeId=" + eventtypeId, formData);
    return data;
  };

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();
    window.location.assign('/admin/eventtypes')
  }

  const handleSelectedFile = (event) => {
    const files = Array.from(event.target.files);
    const statusStep = 100 / files.length;
    for (let i = 0; i < files.length; i++) {
      // uploadItem(files[i]);
      // Here it guarantees that state updated correctly
      // setState(prevStep => prevStep + statusStep);
    }
  };

  useEffect(() => {
    setDisplayPaperImages("none")
  }, [setDisplayPaperImages]);
   
  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 0, md: 0 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="/admin/welcome">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/eventtypes">
              {config.BC_ADMIN_EVENTS}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_EVENTTYPES_CREATE}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 2, paddingLeft: 0, paddingRight: 0, }}
          >
            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Crea tipo evento</b>&nbsp;
            </Typography>
          </Stack>

          <Box
            sx={{ flexDirection: { xs: "column", md: "column" } }}
          >

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 30
              }}
            />

            <Paper
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                background: '#cce0e6'

              }}
              elevation={6}
            >

              <Stack
                useFlexGap
                sx={{
                  flexDirection: { xs: "column", md: "row" },
                  paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                  flexWrap: 'wrap'
                }}
              >

                <TextField id="id-name" label="Nome" variant="outlined"
                  sx={{
                    width: "65ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setName(event.target.value);
                  }}
                />

                <TextField id="id-description" label="Descrizione" variant="outlined"
                  sx={{
                    width: "65ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setDescription(event.target.value);
                  }}
                />

                <TextField id="id-position" label="Posizione" variant="outlined" type="number" InputProps={{ inputProps: { min: 0 } }}
                  sx={{
                    width: "15ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setPosition(event.target.value);
                  }}
                />

                <TextField id="id-color" label="Colore" variant="outlined" type="color"
                  sx={{
                    width: "20ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setColor(event.target.value);
                  }}
                />

                <TextField id="id-note" label="Note" variant="outlined"
                  sx={{
                    width: "65ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setNote(event.target.value);
                  }}
                  multiline
                  rows={3}
                  maxRows={6}
                />

              </Stack>

                <Stack
                  sx={{
                    paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    display: 'flex',
                    flexDirection: { xs: "row", md: "row" },
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >

                  <Button
                    eventtype="button"
                    variant="contained"
                    color="warning"
                    onClick={(e) => { gotoIndietro(e); }}
                    sx={{
                      width: "12ch",
                      p: 1,
                      m: 1,
                    }}
                  >
                    Indietro
                  </Button>

                  <Button
                    variant="contained"
                    eventtype="submit"
                    color="success"
                    onClick={handleSalva}
                    sx={{
                      width: "12ch",
                      p: 1,
                      m: 1,
                    }}
                  >
                    Salva
                  </Button>
                </Stack>

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    height: 20
                  }}
                />

              </Paper>


               <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6',
                  //display: "none"
                  //display: "block"               
                  //display: displayPaperImages
                }}
              >

                <Box
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  }}
                >

                  <Stack
                    sx={{
                      paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      display: 'flex',
                      flexDirection: { xs: "row", md: "row" },
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >

                    <Button
                      variant="contained"
                      color="primary"
                      eventtype="submit"
                      size="small"
                      component="label"
                      fullWidth
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                      }}
                    >
                      Carica immagine
                      <input eventtype="file" onChange={handleLoadImage} hidden multiple />
                    </Button>

                    <Typography variant="h6" color="navy"
                      sx={{
                        width: "20ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      {image.length} immagini caricate
                    </Typography>

                    <Typography variant="h9" color="black"
                      sx={{
                        width: "50ch",
                        p: 1,
                        m: 1,
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 0,
                      }}
                    >
                      puoi modificare titoli e info
                    </Typography>

                  </Stack>

                  <Stack
                    sx={{
                      flexDirection: { xs: "row", md: "row" },
                      paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 1,
                      position: "center", overflowX: "scroll",
                      '@media (min-width: 600px)': { width: '1400px' },
                      '!@media (min-width: 600px)': { width: '500px' },
                    }}
                  >

                    {images.map((image, idx) => (

                      <CreateServiceElementCard key={idx} imagePath={image.path} idx={idx} pageId={id} nameImage={image.name} titleImage={image.title} subTitleImage={image.subTitle} pageAll={eventtype} />

                    ))}

                  </Stack>

                </Box>

              </Paper>


          </Box>

        </Box>


            {/* 

        <Grid
          sx={{
            flexDirection: { xs: "column", md: "row" },
            paddingTop: 2, paddingLeft: 0, paddingRight: 0,
            background: '#cee0e5',
            justifyContent: 'center'
          }}
          container
          size={{ xs: 12, md: 12 }}
          paddingTop={{ xs: 3, md: 3 }}
          paddingLeft={{ xs: 2, md: 8 }}
          paddingRight={{ xs: 1, md: 8 }}
          spacing={{ xs: 2, md: 2 }}
        >

          <Box
            spacing={2}
            style={{ width: "80%", display: "flex", justifyContent: "center", alignItems: "center", }}
            sx={{
              background: '#cee0e5',
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              b: 2,
              m: 2,
              display: 'flex',
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              justifyContent: "center"

            }}
          >

            <Typography variant="h5" color="navy"
              sx={{
                width: "20ch",
                p: 1,
                m: 1,
              }}
            >
               immagini caricate
            </Typography>

            <Button
              variant="contained"
              color="primary"
              eventtype="submit"
              size="large"
              component="label"
              fullWidth
              sx={{
                width: "20ch",
                p: 1,
                m: 1,
              }}
            >
              Carica immagine
                <input eventtype="file" onChange={handleLoadImage} hidden multiple />
            </Button>

          </Box>

          {eventtype.images.map((eventtype, idx) => (

            <AdminConfigsElementCard key={idx} eventtype={eventtype} idx={idx} />

          ))}

        </Grid>

            */}


      </Grid>

    </Box>

  );
};

export default CreateEventtypePageComponent;
